import React from 'react';
import { components } from 'react-select';
import Flag from '../../../flag';
import LanguageSelectFlag from '../flag';
const ValueContainer = (props) => {
  const {
    hasValue,
    children,
    selectProps: { value, inputValue },
  } = props;
  return (
    <components.ValueContainer {...props} className="ws-ui-language-select-value-container">
      {inputValue && hasValue ? (
        <LanguageSelectFlag>{value?.iconComponent}</LanguageSelectFlag>
      ) : (
        <LanguageSelectFlag>
          <Flag code="us" />
        </LanguageSelectFlag>
      )}
      {children}
    </components.ValueContainer>
  );
};

export default ValueContainer;
